import supabase from "@/services/supabaseClient";

function normalizeDisplayName(value = "") {
  return String(value || "").trim().replace(/\s+/g, " ");
}

/**
 * Persists the current authenticated user's shared display identity. The RPC
 * intentionally accepts no user id, so UI lanes cannot select another user's
 * profile, membership, or authority while saving an Account name.
 */
export async function updateOwnAccountDisplayName(displayName) {
  const cleanName = normalizeDisplayName(displayName);
  if (!cleanName) {
    throw new Error("Enter your full name.");
  }

  const { data, error } = await supabase.rpc("update_own_account_display_name", {
    p_display_name: cleanName,
  });
  if (error) throw error;

  const result = Array.isArray(data) ? data[0] : data;
  if (!result?.ok) {
    throw new Error("We couldn’t save your shared account identity.");
  }

  // Refresh the client-side auth metadata fallback as well as the shared
  // profile row, so headers and initials do not wait for a later sign-in.
  await supabase.auth.refreshSession().catch(() => {
    // The saved profile remains authoritative; AuthContext also refreshes it.
  });
  return result;
}

export { normalizeDisplayName };
